(function (angular) {
	'use strict';

	angular.module('app')
		.service('Subevents', Subevents);

	Subevents.$inject = [
		'modalService'
	];

	function Subevents(
		modalService
	) {

		/**
		 * Opens a modal window allowing the user to create a sub-event.
		 * 
		 * @return {void}
		 */
		function createSubevent(eventId) {
			return modalService.open({
				templateUrl: 'modals/manage-subevent.html',
				controller: 'manageSubeventController',
				controllerAs: 'vm',
				windowClass: 'manage-subevent',
				resolve: {
					eventId: function () {
						return eventId;
					},
					subeventId: function() {
						return null;
					},
				},
			});
		}

		/**
		 * Opens a modal window allowing the user to edit a sub-event.
		 *
		 * @param  {Number} subeventId
		 * @return {void}
		 */
		function editSubevent(eventId, subeventId) {
			return modalService.open({
				templateUrl: 'modals/manage-subevent.html',
				controller: 'manageSubeventController',
				controllerAs: 'vm',
				windowClass: 'manage-subevent',
				resolve: {
					eventId: function () {
						return eventId;
					},
					subeventId: function() {
						return subeventId;
					},
				},
			});
		}

		return {
			create: createSubevent,
			edit: editSubevent,
		};

	}
}(angular));